import { ROUTE_ANCHOR, routesAndPagesMap } from "Common/routingUtils";
import get from "lodash/get";
import trimStart from "lodash/trimStart";
import { LOCATION_CHANGE } from "redux-first-history";
const getRoutingKey = (hash) => {
    const actualHash = trimStart(hash, ROUTE_ANCHOR);
    return (routesAndPagesMap.getByHash(actualHash, false) || {
        key: routesAndPagesMap.getWithNoRoute()
    });
};
export default (state, action) => {
    if ((action === null || action === void 0 ? void 0 : action.type) === LOCATION_CHANGE) {
        return getRoutingKey(action.payload.location.hash);
    }
    return state || {};
};
export const routingMiddleware = () => (next) => (action) => {
    if ((action === null || action === void 0 ? void 0 : action.type) === LOCATION_CHANGE) {
        const routing = getRoutingKey(action.payload.location.hash);
        next(action);
        next({ type: routing.key, payload: get(routing, "payload") });
    }
    else {
        next(action);
    }
};
